export default __webpack_public_path__ + "static/media/nserix-dark.e7ad1dad.svg";